module.exports = __webpack_public_path__ + "static/media/Avenir-Black.0cc5ea08.svg";